// Text for the hidden tricks: the first-visit popup, the tricks list and the terminal.

export const TRICKS_T = {
  en: {
    unlocked: "🔓 Visit #{n}: you unlocked the hidden tricks!",
    introTitle: "This site has hidden tricks!",
    introText: "There are secret features hidden around the website. Want to see what you can do?",
    showMe: "Show me the tricks",
    later: "Maybe later",
    panelTitle: "🎩 Hidden tricks",
    panelHint: "You can open this list anytime with the 🎩 button.",
    tryIt: "Try it",
    close: "Close",
    open: "Show hidden tricks",
    items: {
      terminal: { title: "Secret terminal", how: "Press ~ (or `) anywhere on the page." },
      matrix: { title: "Matrix mode", how: "Type the Konami code: ↑ ↑ ↓ ↓ ← → ← → B A" },
      roll: { title: "Barrel roll", how: "Click my profile picture 5 times." },
      hack: { title: "Hacker mode", how: "Type hack in the terminal." },
      light: { title: "Light mode?", how: "Press the ☀️ button in the top bar." },
    },
    term: {
      welcome: "Welcome to Chouaib's terminal. Type 'help' to see the commands.",
      hint: "Esc to close",
      notFound: "command not found: {cmd}. Type 'help'.",
      helpTitle: "Available commands:",
      cmds: {
        help: "show this list",
        whoami: "who is Chouaib?",
        about: "a few words about me",
        projects: "what I've built",
        skills: "the magic behind",
        contact: "how to reach me",
        open: "open github | linkedin | email",
        lang: "change language, e.g. lang fr",
        date: "today's date and time",
        echo: "repeat what you type",
        matrix: "enter the Matrix",
        roll: "do a barrel roll",
        hack: "hack the mainframe",
        clear: "clear the screen",
        exit: "close the terminal",
      },
      sudo: "Nice try. This incident will be reported. 🚨",
      hackSteps: ["Connecting to the mainframe…", "Bypassing the firewall…", "Decrypting passwords…", "Downloading secret files…"],
      hackDone: "Access granted… just kidding 😄",
      langChanged: "Language changed to {name}.",
      langUsage: "Usage: lang <code>   ({codes})",
      openUsage: "Usage: open github | linkedin | email",
      matrixOn: "Wake up, Neo… (click or press Esc to stop)",
      rollOn: "Do a barrel roll! 🌀",
      bye: "Bye! 👋",
    },
  },

  fr: {
    unlocked: "🔓 Visite n°{n} : vous avez débloqué les astuces cachées !",
    introTitle: "Ce site cache des astuces !",
    introText: "Des fonctionnalités secrètes sont cachées un peu partout sur le site. Voulez-vous voir ce que vous pouvez faire ?",
    showMe: "Montrez-moi les astuces",
    later: "Plus tard",
    panelTitle: "🎩 Astuces cachées",
    panelHint: "Vous pouvez rouvrir cette liste à tout moment avec le bouton 🎩.",
    tryIt: "Essayer",
    close: "Fermer",
    open: "Voir les astuces cachées",
    items: {
      terminal: { title: "Terminal secret", how: "Appuyez sur ~ (ou `) n'importe où sur la page." },
      matrix: { title: "Mode Matrix", how: "Tapez le code Konami : ↑ ↑ ↓ ↓ ← → ← → B A" },
      roll: { title: "Tonneau", how: "Cliquez 5 fois sur ma photo de profil." },
      hack: { title: "Mode hacker", how: "Tapez hack dans le terminal." },
      light: { title: "Mode clair ?", how: "Appuyez sur le bouton ☀️ de la barre du haut." },
    },
    term: {
      welcome: "Bienvenue dans le terminal de Chouaib. Tapez « help » pour voir les commandes.",
      hint: "Échap pour fermer",
      notFound: "commande introuvable : {cmd}. Tapez « help ».",
      helpTitle: "Commandes disponibles :",
      cmds: {
        help: "afficher cette liste",
        whoami: "qui est Chouaib ?",
        about: "quelques mots sur moi",
        projects: "mes réalisations",
        skills: "la magie derrière",
        contact: "comment me joindre",
        open: "ouvrir github | linkedin | email",
        lang: "changer de langue, ex. lang en",
        date: "la date et l'heure",
        echo: "répéter ce que vous tapez",
        matrix: "entrer dans la Matrice",
        roll: "faire un tonneau",
        hack: "pirater l'ordinateur central",
        clear: "effacer l'écran",
        exit: "fermer le terminal",
      },
      sudo: "Bien essayé. Cet incident sera signalé. 🚨",
      hackSteps: ["Connexion à l'ordinateur central…", "Contournement du pare-feu…", "Déchiffrement des mots de passe…", "Téléchargement des fichiers secrets…"],
      hackDone: "Accès autorisé… je plaisante 😄",
      langChanged: "Langue changée : {name}.",
      langUsage: "Utilisation : lang <code>   ({codes})",
      openUsage: "Utilisation : open github | linkedin | email",
      matrixOn: "Réveille-toi, Neo… (cliquez ou appuyez sur Échap pour arrêter)",
      rollOn: "Un tonneau ! 🌀",
      bye: "Au revoir ! 👋",
    },
  },

  ar: {
    unlocked: "🔓 الزيارة رقم {n}: لقد فتحت الحيل المخفية!",
    introTitle: "هذا الموقع يخفي حيلًا سرية!",
    introText: "هناك ميزات سرية مخبأة في أنحاء الموقع. هل تريد أن ترى ما يمكنك فعله؟",
    showMe: "أرني الحيل",
    later: "لاحقًا",
    panelTitle: "🎩 الحيل المخفية",
    panelHint: "يمكنك فتح هذه القائمة في أي وقت عبر زر 🎩.",
    tryIt: "جرّبها",
    close: "إغلاق",
    open: "عرض الحيل المخفية",
    items: {
      terminal: { title: "الطرفية السرية", how: "اضغط ~ (أو `) في أي مكان من الصفحة." },
      matrix: { title: "وضع الماتريكس", how: "اكتب رمز كونامي: ↑ ↑ ↓ ↓ ← → ← → B A" },
      roll: { title: "الدوران", how: "انقر على صورتي الشخصية 5 مرات." },
      hack: { title: "وضع الهاكر", how: "اكتب hack في الطرفية." },
      light: { title: "الوضع الفاتح؟", how: "اضغط زر ☀️ في الشريط العلوي." },
    },
    term: {
      welcome: "مرحبًا بك في طرفية شعيب. اكتب help لعرض الأوامر.",
      hint: "Esc للإغلاق",
      notFound: "الأمر غير موجود: {cmd}. اكتب help.",
      helpTitle: "الأوامر المتاحة:",
      cmds: {
        help: "عرض هذه القائمة",
        whoami: "من هو شعيب؟",
        about: "كلمات قليلة عني",
        projects: "ما قمت ببنائه",
        skills: "السحر من وراء الكواليس",
        contact: "كيف تتواصل معي",
        open: "فتح github | linkedin | email",
        lang: "تغيير اللغة، مثل lang en",
        date: "التاريخ والوقت الآن",
        echo: "تكرار ما تكتبه",
        matrix: "ادخل إلى الماتريكس",
        roll: "قم بدورة كاملة",
        hack: "اخترق الحاسوب المركزي",
        clear: "مسح الشاشة",
        exit: "إغلاق الطرفية",
      },
      sudo: "محاولة جيدة. سيتم الإبلاغ عن هذه الحادثة. 🚨",
      hackSteps: ["جارٍ الاتصال بالحاسوب المركزي…", "جارٍ تجاوز الجدار الناري…", "جارٍ فك تشفير كلمات المرور…", "جارٍ تنزيل الملفات السرية…"],
      hackDone: "تم منح الوصول… أمزح فقط 😄",
      langChanged: "تم تغيير اللغة إلى {name}.",
      langUsage: "الاستخدام: lang <code>   ({codes})",
      openUsage: "الاستخدام: open github | linkedin | email",
      matrixOn: "استيقظ يا نيو… (انقر أو اضغط Esc للإيقاف)",
      rollOn: "دورة كاملة! 🌀",
      bye: "إلى اللقاء! 👋",
    },
  },

  it: {
    unlocked: "🔓 Visita n. {n}: hai sbloccato i trucchi nascosti!",
    introTitle: "Questo sito nasconde dei trucchi!",
    introText: "Ci sono funzioni segrete nascoste nel sito. Vuoi vedere cosa puoi fare?",
    showMe: "Mostrami i trucchi",
    later: "Più tardi",
    panelTitle: "🎩 Trucchi nascosti",
    panelHint: "Puoi riaprire questa lista in qualsiasi momento con il pulsante 🎩.",
    tryIt: "Prova",
    close: "Chiudi",
    open: "Mostra i trucchi nascosti",
    items: {
      terminal: { title: "Terminale segreto", how: "Premi ~ (o `) in qualsiasi punto della pagina." },
      matrix: { title: "Modalità Matrix", how: "Digita il codice Konami: ↑ ↑ ↓ ↓ ← → ← → B A" },
      roll: { title: "Giro della morte", how: "Clicca 5 volte sulla mia foto profilo." },
      hack: { title: "Modalità hacker", how: "Digita hack nel terminale." },
      light: { title: "Modalità chiara?", how: "Premi il pulsante ☀️ nella barra in alto." },
    },
    term: {
      welcome: "Benvenuto nel terminale di Chouaib. Digita 'help' per vedere i comandi.",
      hint: "Esc per chiudere",
      notFound: "comando non trovato: {cmd}. Digita 'help'.",
      helpTitle: "Comandi disponibili:",
      cmds: {
        help: "mostra questa lista",
        whoami: "chi è Chouaib?",
        about: "due parole su di me",
        projects: "cosa ho realizzato",
        skills: "la magia dietro le quinte",
        contact: "come contattarmi",
        open: "apri github | linkedin | email",
        lang: "cambia lingua, es. lang en",
        date: "data e ora di oggi",
        echo: "ripete quello che scrivi",
        matrix: "entra in Matrix",
        roll: "fai un giro della morte",
        hack: "hackera il mainframe",
        clear: "pulisci lo schermo",
        exit: "chiudi il terminale",
      },
      sudo: "Bel tentativo. Questo incidente verrà segnalato. 🚨",
      hackSteps: ["Connessione al mainframe…", "Aggiramento del firewall…", "Decifratura delle password…", "Download dei file segreti…"],
      hackDone: "Accesso consentito… scherzo 😄",
      langChanged: "Lingua cambiata in {name}.",
      langUsage: "Uso: lang <codice>   ({codes})",
      openUsage: "Uso: open github | linkedin | email",
      matrixOn: "Svegliati, Neo… (clicca o premi Esc per fermare)",
      rollOn: "Giro della morte! 🌀",
      bye: "Ciao! 👋",
    },
  },

  de: {
    unlocked: "🔓 Besuch Nr. {n}: Du hast die versteckten Tricks freigeschaltet!",
    introTitle: "Diese Seite hat versteckte Tricks!",
    introText: "Auf der Website sind geheime Funktionen versteckt. Willst du sehen, was du alles tun kannst?",
    showMe: "Zeig mir die Tricks",
    later: "Vielleicht später",
    panelTitle: "🎩 Versteckte Tricks",
    panelHint: "Du kannst diese Liste jederzeit über den 🎩-Button öffnen.",
    tryIt: "Ausprobieren",
    close: "Schließen",
    open: "Versteckte Tricks anzeigen",
    items: {
      terminal: { title: "Geheimes Terminal", how: "Drücke irgendwo auf der Seite ~ (oder `)." },
      matrix: { title: "Matrix-Modus", how: "Gib den Konami-Code ein: ↑ ↑ ↓ ↓ ← → ← → B A" },
      roll: { title: "Fassrolle", how: "Klicke 5-mal auf mein Profilbild." },
      hack: { title: "Hacker-Modus", how: "Gib hack im Terminal ein." },
      light: { title: "Heller Modus?", how: "Drücke den ☀️-Button oben in der Leiste." },
    },
    term: {
      welcome: "Willkommen in Chouaibs Terminal. Gib 'help' ein, um die Befehle zu sehen.",
      hint: "Esc zum Schließen",
      notFound: "Befehl nicht gefunden: {cmd}. Gib 'help' ein.",
      helpTitle: "Verfügbare Befehle:",
      cmds: {
        help: "diese Liste anzeigen",
        whoami: "wer ist Chouaib?",
        about: "ein paar Worte über mich",
        projects: "was ich gebaut habe",
        skills: "die Magie dahinter",
        contact: "wie du mich erreichst",
        open: "github | linkedin | email öffnen",
        lang: "Sprache wechseln, z. B. lang en",
        date: "heutiges Datum und Uhrzeit",
        echo: "wiederholt deine Eingabe",
        matrix: "betritt die Matrix",
        roll: "mach eine Fassrolle",
        hack: "hack den Großrechner",
        clear: "Bildschirm leeren",
        exit: "Terminal schließen",
      },
      sudo: "Netter Versuch. Dieser Vorfall wird gemeldet. 🚨",
      hackSteps: ["Verbindung zum Großrechner…", "Firewall wird umgangen…", "Passwörter werden entschlüsselt…", "Geheime Dateien werden geladen…"],
      hackDone: "Zugriff gewährt… nur ein Scherz 😄",
      langChanged: "Sprache geändert zu {name}.",
      langUsage: "Verwendung: lang <code>   ({codes})",
      openUsage: "Verwendung: open github | linkedin | email",
      matrixOn: "Wach auf, Neo… (klicken oder Esc drücken zum Beenden)",
      rollOn: "Fassrolle! 🌀",
      bye: "Tschüss! 👋",
    },
  },

  zh: {
    unlocked: "🔓 第 {n} 次访问：你解锁了隐藏彩蛋！",
    introTitle: "这个网站藏着彩蛋！",
    introText: "网站各处藏着一些秘密功能。想看看你能做些什么吗？",
    showMe: "给我看看彩蛋",
    later: "以后再说",
    panelTitle: "🎩 隐藏彩蛋",
    panelHint: "你可以随时点击 🎩 按钮重新打开这个列表。",
    tryIt: "试一试",
    close: "关闭",
    open: "查看隐藏彩蛋",
    items: {
      terminal: { title: "秘密终端", how: "在页面任意位置按 ~（或 `）。" },
      matrix: { title: "黑客帝国模式", how: "输入科乐美秘技：↑ ↑ ↓ ↓ ← → ← → B A" },
      roll: { title: "翻滚", how: "点击我的头像 5 次。" },
      hack: { title: "黑客模式", how: "在终端中输入 hack。" },
      light: { title: "浅色模式？", how: "点击顶部栏的 ☀️ 按钮。" },
    },
    term: {
      welcome: "欢迎来到 Chouaib 的终端。输入 help 查看命令。",
      hint: "按 Esc 关闭",
      notFound: "找不到命令：{cmd}。请输入 help。",
      helpTitle: "可用命令：",
      cmds: {
        help: "显示此列表",
        whoami: "Chouaib 是谁？",
        about: "关于我的几句话",
        projects: "我的作品",
        skills: "幕后的魔法",
        contact: "如何联系我",
        open: "打开 github | linkedin | email",
        lang: "切换语言，例如 lang en",
        date: "今天的日期和时间",
        echo: "重复你输入的内容",
        matrix: "进入黑客帝国",
        roll: "来个翻滚",
        hack: "入侵主机",
        clear: "清空屏幕",
        exit: "关闭终端",
      },
      sudo: "想得美。此事件将被上报。🚨",
      hackSteps: ["正在连接主机…", "正在绕过防火墙…", "正在解密密码…", "正在下载机密文件…"],
      hackDone: "访问已授权……开玩笑的 😄",
      langChanged: "语言已切换为 {name}。",
      langUsage: "用法：lang <代码>   ({codes})",
      openUsage: "用法：open github | linkedin | email",
      matrixOn: "醒醒，尼奥……（点击或按 Esc 停止）",
      rollOn: "翻滚吧！🌀",
      bye: "再见！👋",
    },
  },

  ja: {
    unlocked: "🔓 {n}回目の訪問：隠し技が解放されました！",
    introTitle: "このサイトには隠し技があります！",
    introText: "サイトのあちこちに秘密の機能が隠れています。何ができるか見てみますか？",
    showMe: "隠し技を見る",
    later: "あとで",
    panelTitle: "🎩 隠し技",
    panelHint: "🎩ボタンでいつでもこのリストを開けます。",
    tryIt: "試す",
    close: "閉じる",
    open: "隠し技を見る",
    items: {
      terminal: { title: "秘密のターミナル", how: "ページのどこでも ~（または `）を押します。" },
      matrix: { title: "マトリックスモード", how: "コナミコマンドを入力：↑ ↑ ↓ ↓ ← → ← → B A" },
      roll: { title: "バレルロール", how: "プロフィール画像を5回クリックします。" },
      hack: { title: "ハッカーモード", how: "ターミナルで hack と入力します。" },
      light: { title: "ライトモード？", how: "上部バーの ☀️ ボタンを押します。" },
    },
    term: {
      welcome: "Chouaibのターミナルへようこそ。help と入力するとコマンド一覧が表示されます。",
      hint: "Escで閉じる",
      notFound: "コマンドが見つかりません：{cmd}。help と入力してください。",
      helpTitle: "使えるコマンド：",
      cmds: {
        help: "この一覧を表示",
        whoami: "Chouaibって誰？",
        about: "自己紹介",
        projects: "これまでに作ったもの",
        skills: "舞台裏の魔法",
        contact: "連絡方法",
        open: "github | linkedin | email を開く",
        lang: "言語を変更（例：lang en）",
        date: "今日の日付と時刻",
        echo: "入力した文字を繰り返す",
        matrix: "マトリックスに入る",
        roll: "バレルロールする",
        hack: "メインフレームをハックする",
        clear: "画面をクリア",
        exit: "ターミナルを閉じる",
      },
      sudo: "いい試みですね。この件は報告されます。🚨",
      hackSteps: ["メインフレームに接続中…", "ファイアウォールを回避中…", "パスワードを解読中…", "機密ファイルをダウンロード中…"],
      hackDone: "アクセス許可…なんてね 😄",
      langChanged: "言語を{name}に変更しました。",
      langUsage: "使い方：lang <コード>   ({codes})",
      openUsage: "使い方：open github | linkedin | email",
      matrixOn: "目覚めよ、ネオ…（クリックかEscで停止）",
      rollOn: "バレルロール！🌀",
      bye: "またね！👋",
    },
  },
};
